<template>
  <div>
    <Banner />
    <section class="hero">
      <index-hero-carousel />
    </section>
    <section class="featured">
      <div>
        <h2>爆款来袭</h2>
        <div class="featured-row">
          <featured-spark
            :title="'Spark'"
            :revision="'GUITAR'"
            :desc="'智 能 吉 他 音 箱'"
            :link="'/spark'"
          />
        </div>
        <div class="featured-row">
          <featured-small
            :title="'BIAS FX 2'"
            :desc="'音色的新纪元'"
            :link="'/bias-fx2'"
          />
          <!-- <featured-small
            :title="'BIAS FX'"
            :revision="'移动版'"
            :desc="'完整的 iOS 吉他音箱和效果器'"
            :link="'/bias-fx-mobile'"
          /> -->
          <featured-small :link="''" />
        </div>
        <!-- <div class="featured-row">
          <featured-large
            :title="'BIAS MINI'"
            :revision="'GUITAR'"
            :desc="'小身材 大能量'"
            :link="'/bias-mini-guitar'"
          />
        </div> -->
      </div>
    </section>
    <footer-weixin />
    <footer-common />
  </div>
</template>

<script>
import Banner from '@/components/banner'
import FooterWeixin from '@/components/footer-weixin'
import FooterCommon from '@/components/footer-common'
import FeaturedSmall from '@/components/featured-small'
// import FeaturedLarge from '@/components/featured-large'
import FeaturedSpark from '@/components/featured-spark'
import IndexHeroCarousel from '@/components/index-hero-carousel'

export default {
  name: 'Index',
  components: {
    Banner,
    FooterWeixin,
    FooterCommon,
    FeaturedSmall,
    // FeaturedLarge,
    IndexHeroCarousel,
    FeaturedSpark
  },
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style scoped>
.hero {
    margin-top: 54px;
    min-height: 620px;
}
.featured {
    background-image: linear-gradient(to bottom, #bcbcbc, #d8d8d8);
    padding-bottom: 10%;
}

.featured > div {
    width: 76%;
    margin: 0 auto;
}
.featured > div > h2 {
    font-size: 50px;
    color: black;
    text-align: center;
    padding-top: 54px;
    margin: 0;
}

.featured-row {
    display: flex;
    justify-content: space-around;
}

@media only screen and (max-width: 768px) {
    .featured-row {
        display: block;
    }
    .hero {
        margin-top: 44px;
        min-height: 125vw;
    }
    .featured > div {
        width: 99%;
        margin: 0 auto;
    }
}
@media only screen and (max-width: 558px) {
    .hero {
        background-size: contain;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue